// 引入createStore创建store，引入applyMiddleware 来使用中间件
import { createStore, compose, applyMiddleware, combineReducers } from 'redux'
// 引入所有的reducer
import common from '../reducer/common'
// 中间件
import thunk from 'redux-thunk'

// 初始化数据
const reduer = combineReducers({
  common,
})

// 调试工具与中间件
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose
const enhancer = composeEnhancers(
  applyMiddleware(thunk),
)

const configureStore = () => createStore(reduer, enhancer)

export default configureStore